import { CategoryDto } from '@or-sdk/billing';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import { Billing as billingApi } from '@/api';
import { TranslatableError } from '@/errors';
import { fetchPagedData } from '@/utils/fetchPagedData';

const useCategoriesStore = defineStore('categories', () => {
  const categoriesRawData = ref<CategoryDto[]>([]);

  const categoriesList = computed(() => {
    return categoriesRawData.value.map(el => ({
      name: el.name,
      value: el.name.toLowerCase().split(' ').join('_'),
    }));
  });

  const categorySkuOptions = computed(() => {
    return categoriesRawData.value.map(el => ({
      label: el.name,
      value: el.name,
    }));
  });

  const categoriesMap = computed(() => {
    return categoriesRawData.value.reduce((acc, el) => {
      if (!acc[el.skuCode]) acc[el.skuCode] = el.name;
      return acc;
    }, {} as Record<string, string>);
  });

  async function getCategories() {
    try {
      categoriesRawData.value = await fetchPagedData((f) => billingApi.categoriesApi.getCategories(f), {});
    } catch (e) {
      console.error('Failed to get categories', e);
      throw new TranslatableError('errors.getCategories');
    }
  }

  return {
    categoriesRawData,
    categoriesList,
    categorySkuOptions,
    categoriesMap,
    getCategories,
  };
});

export default useCategoriesStore;
